module.exports = __webpack_public_path__ + "img/4.7d89194b.png";